var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { webhooksApi, constantsApi, propertiesApi, propertyChannelMappingsApi } from '@/utils/apiService';
import { Typography, Box, Paper, Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Alert, CircularProgress, TextField, Checkbox, FormControlLabel, Chip, Card, CardContent, CardActions, MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, Save as SaveIcon, Refresh as RefreshIcon, Webhook as WebhookIcon, PlayArrow as TestIcon, ToggleOff as InactiveIcon, ToggleOn as ActiveIcon, Sync as SyncIcon } from '@mui/icons-material';
var WebhookManagement = function () {
    var _a = useState([]), channexWebhooks = _a[0], setChannexWebhooks = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(false), createDialogOpen = _d[0], setCreateDialogOpen = _d[1];
    var _e = useState(false), editDialogOpen = _e[0], setEditDialogOpen = _e[1];
    var _f = useState(null), selectedWebhook = _f[0], setSelectedWebhook = _f[1];
    var _g = useState(''), newWebhookUrl = _g[0], setNewWebhookUrl = _g[1];
    var _h = useState([]), selectedEvents = _h[0], setSelectedEvents = _h[1];
    var _j = useState(true), selectedIsActive = _j[0], setSelectedIsActive = _j[1];
    var _k = useState(true), selectedSendData = _k[0], setSelectedSendData = _k[1];
    var _l = useState(false), operationLoading = _l[0], setOperationLoading = _l[1];
    var _m = useState([]), availableEvents = _m[0], setAvailableEvents = _m[1];
    var _o = useState([]), properties = _o[0], setProperties = _o[1];
    var _p = useState([]), propertyChannelMappings = _p[0], setPropertyChannelMappings = _p[1];
    var _q = useState(''), selectedPropertyId = _q[0], setSelectedPropertyId = _q[1];
    var _r = useState(null), connectionStatus = _r[0], setConnectionStatus = _r[1];
    var _s = useState(false), testingConnection = _s[0], setTestingConnection = _s[1];
    useEffect(function () {
        fetchChannexWebhooks();
        fetchAvailableEvents();
        fetchProperties();
    }, []);
    var fetchAvailableEvents = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, eventValues, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, constantsApi.getWebhookConstants()];
                case 1:
                    response = _a.sent();
                    if (response.event_types) {
                        eventValues = response.event_types.map(function (event) { return event.value; });
                        setAvailableEvents(eventValues);
                    }
                    else {
                        // Fallback to static events if API doesn't return them - Channex exact format
                        setAvailableEvents([
                            'ari',
                            'booking',
                            'booking_new',
                            'booking_modification',
                            'booking_cancellation',
                            'sync_error',
                            'reservation_request',
                            'booking_unmapped_room',
                            'booking_unmapped_rate',
                            'sync_warning',
                            'message',
                            'review',
                            'alteration_request',
                            'inquiry',
                            'disconnect_channel',
                            'disconnect_listing',
                            'rate_error',
                            'accepted_reservation',
                            'declined_reservation',
                            'non_acked_booking',
                            'new_channel',
                            'updated_channel',
                            'updated_review'
                        ]);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error('Failed to fetch available events:', err_1);
                    // Fallback to static events - Channex exact format
                    setAvailableEvents([
                        'ari',
                        'booking',
                        'booking_new',
                        'booking_modification',
                        'booking_cancellation',
                        'sync_error',
                        'reservation_request',
                        'booking_unmapped_room',
                        'booking_unmapped_rate',
                        'sync_warning',
                        'message',
                        'review',
                        'alteration_request',
                        'inquiry',
                        'disconnect_channel',
                        'disconnect_listing',
                        'rate_error',
                        'accepted_reservation',
                        'declined_reservation',
                        'non_acked_booking',
                        'new_channel',
                        'updated_channel',
                        'updated_review'
                    ]);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchProperties = function () { return __awaiter(void 0, void 0, void 0, function () {
        var propertiesResponse, propertiesData, mappingsResponse, mappingsData, channexMappings, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, propertiesApi.getAll()];
                case 1:
                    propertiesResponse = _a.sent();
                    propertiesData = propertiesResponse.results || propertiesResponse || [];
                    console.log('Properties loaded:', propertiesData.length, propertiesData);
                    setProperties(propertiesData);
                    return [4 /*yield*/, propertyChannelMappingsApi.getAll()];
                case 2:
                    mappingsResponse = _a.sent();
                    mappingsData = mappingsResponse.results || mappingsResponse || [];
                    console.log('Channel mappings loaded:', mappingsData.length, mappingsData);
                    channexMappings = mappingsData.filter(function (mapping) {
                        return mapping.is_active && mapping.external_property_id;
                    });
                    console.log('Active Channex mappings:', channexMappings.length, channexMappings);
                    setPropertyChannelMappings(channexMappings);
                    // Auto-select first property with Channex mapping if available
                    if (channexMappings.length > 0 && !selectedPropertyId) {
                        console.log('Auto-selecting first Channex mapping:', channexMappings[0].external_property_id);
                        setSelectedPropertyId(channexMappings[0].external_property_id);
                    }
                    else if (propertiesData.length > 0 && !selectedPropertyId) {
                        // Fallback to first property ID if no Channex mappings
                        console.log('No Channex mappings, using first property ID as fallback:', propertiesData[0].id.toString());
                        setSelectedPropertyId(propertiesData[0].id.toString());
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    console.error('Failed to fetch properties and mappings:', err_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var fetchChannexWebhooks = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, webhooksApi.manageChannexWebhooks({ action: 'list' })];
                case 1:
                    response = _a.sent();
                    setChannexWebhooks(response.webhooks || []);
                    setError(null);
                    return [3 /*break*/, 4];
                case 2:
                    err_3 = _a.sent();
                    setError(err_3 instanceof Error ? err_3.message : 'Failed to fetch Channex webhooks');
                    setChannexWebhooks([]); // Ensure we have a valid array even on error
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCreateWebhook = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestData, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!newWebhookUrl || selectedEvents.length === 0 || !selectedPropertyId) {
                        setError('URL, property, and at least one event are required');
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setOperationLoading(true);
                    requestData = {
                        action: 'create',
                        webhook_data: {
                            webhook: {
                                url: newWebhookUrl,
                                events: selectedEvents, // Send as array with selected events
                                property_id: selectedPropertyId,
                                is_active: selectedIsActive,
                                send_data: selectedSendData
                            }
                        }
                    };
                    console.log('Creating webhook with data:', JSON.stringify(requestData, null, 2));
                    return [4 /*yield*/, webhooksApi.manageChannexWebhooks(requestData)];
                case 2:
                    _a.sent();
                    setCreateDialogOpen(false);
                    setNewWebhookUrl('');
                    setSelectedEvents([]);
                    setSelectedPropertyId(propertyChannelMappings.length > 0
                        ? propertyChannelMappings[0].external_property_id
                        : (properties.length > 0 ? properties[0].id.toString() : ''));
                    fetchChannexWebhooks();
                    setError(null);
                    return [3 /*break*/, 5];
                case 3:
                    err_4 = _a.sent();
                    setError(err_4 instanceof Error ? err_4.message : 'Failed to create webhook');
                    return [3 /*break*/, 5];
                case 4:
                    setOperationLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateWebhook = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedWebhook || !newWebhookUrl || selectedEvents.length === 0 || !selectedPropertyId) {
                        setError('Webhook, URL, property, and at least one event are required');
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setOperationLoading(true);
                    return [4 /*yield*/, webhooksApi.manageChannexWebhooks({
                            action: 'update',
                            webhook_id: selectedWebhook.id,
                            webhook_data: {
                                webhook: {
                                    url: newWebhookUrl,
                                    events: selectedEvents,
                                    property_id: selectedPropertyId,
                                    is_active: selectedIsActive,
                                    send_data: selectedSendData
                                }
                            }
                        })];
                case 2:
                    _a.sent();
                    setEditDialogOpen(false);
                    setSelectedWebhook(null);
                    setNewWebhookUrl('');
                    setSelectedEvents([]);
                    setSelectedPropertyId(propertyChannelMappings.length > 0
                        ? propertyChannelMappings[0].external_property_id
                        : (properties.length > 0 ? properties[0].id.toString() : ''));
                    fetchChannexWebhooks();
                    setError(null);
                    return [3 /*break*/, 5];
                case 3:
                    err_5 = _a.sent();
                    setError(err_5 instanceof Error ? err_5.message : 'Failed to update webhook');
                    return [3 /*break*/, 5];
                case 4:
                    setOperationLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteWebhook = function (webhookId) { return __awaiter(void 0, void 0, void 0, function () {
        var err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm('Are you sure you want to delete this webhook?')) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setOperationLoading(true);
                    return [4 /*yield*/, webhooksApi.manageChannexWebhooks({
                            action: 'delete',
                            webhook_id: webhookId
                        })];
                case 2:
                    _a.sent();
                    fetchChannexWebhooks();
                    setError(null);
                    return [3 /*break*/, 5];
                case 3:
                    err_6 = _a.sent();
                    setError(err_6 instanceof Error ? err_6.message : 'Failed to delete webhook');
                    return [3 /*break*/, 5];
                case 4:
                    setOperationLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleToggleWebhook = function (webhook) { return __awaiter(void 0, void 0, void 0, function () {
        var err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setOperationLoading(true);
                    return [4 /*yield*/, webhooksApi.manageChannexWebhooks({
                            action: 'update',
                            webhook_id: webhook.id,
                            webhook_data: {
                                url: webhook.url,
                                events: webhook.events,
                                property_id: webhook.property_id || selectedPropertyId,
                                is_active: !webhook.is_active
                            }
                        })];
                case 1:
                    _a.sent();
                    fetchChannexWebhooks();
                    setError(null);
                    return [3 /*break*/, 4];
                case 2:
                    err_7 = _a.sent();
                    setError(err_7 instanceof Error ? err_7.message : 'Failed to toggle webhook');
                    return [3 /*break*/, 4];
                case 3:
                    setOperationLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleTestWebhook = function (webhook) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setOperationLoading(true);
                    return [4 /*yield*/, webhooksApi.manageChannexWebhooks({
                            action: 'test',
                            webhook_data: {
                                id: webhook.id,
                                url: webhook.url,
                                events: webhook.events,
                                property_id: webhook.property_id || selectedPropertyId
                            }
                        })];
                case 1:
                    response = _a.sent();
                    if (response.success) {
                        alert('✅ Webhook test successful! Connection is working correctly.');
                    }
                    else {
                        alert("\u274C Webhook test failed: ".concat(response.message || 'Unknown error'));
                    }
                    return [3 /*break*/, 4];
                case 2:
                    err_8 = _a.sent();
                    alert("\u274C Webhook test failed: ".concat(err_8 instanceof Error ? err_8.message : 'Network error'));
                    return [3 /*break*/, 4];
                case 3:
                    setOperationLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var openCreateDialog = function () {
        // Channex requires HTTPS with port 443
        var hostname = window.location.hostname;
        // Use ngrok URL if available, otherwise construct HTTPS URL
        var webhookUrl;
        if (hostname.includes('ngrok') || hostname.includes('.app')) {
            // Use ngrok or other tunnel service as-is
            webhookUrl = "https://".concat(hostname, "/api/v1/channel_manager/webhooks/channex/");
        }
        else {
            // Use standard HTTPS with port 443
            var port = window.location.port;
            if (port != '80') {
                webhookUrl = "https://".concat(hostname, ":").concat(port, "/api/v1/channel_manager/webhooks/channex/");
            }
            else {
                webhookUrl = "https://".concat(hostname, "/api/v1/channel_manager/webhooks/channex/");
            }
        }
        setNewWebhookUrl(webhookUrl.trim());
        setSelectedEvents([]);
        setSelectedIsActive(true);
        setSelectedSendData(true);
        // Determine default property ID
        var defaultPropId = propertyChannelMappings.length > 0
            ? propertyChannelMappings[0].external_property_id
            : (properties.length > 0 ? properties[0].id.toString() : '');
        setSelectedPropertyId(defaultPropId);
        setCreateDialogOpen(true);
    };
    var openEditDialog = function (webhook) {
        setSelectedWebhook(webhook);
        setNewWebhookUrl(webhook.url);
        setSelectedEvents(webhook.events || []);
        // Ensure we use the property_id from the webhook, which should match external_property_id in mappings
        setSelectedPropertyId(webhook.property_id || '');
        setSelectedIsActive(webhook.is_active !== undefined ? webhook.is_active : true);
        setSelectedSendData(webhook.send_data !== undefined ? webhook.send_data : true);
        setEditDialogOpen(true);
    };
    var testChannexConnection = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setTestingConnection(true);
                    setConnectionStatus(null);
                    return [4 /*yield*/, webhooksApi.testChannexConnection(1)];
                case 1:
                    response = _a.sent();
                    setConnectionStatus(response);
                    return [3 /*break*/, 4];
                case 2:
                    err_9 = _a.sent();
                    console.error('Error testing connection:', err_9);
                    setConnectionStatus({
                        success: false,
                        message: err_9 instanceof Error ? err_9.message : 'Failed to test connection'
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setTestingConnection(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSyncWebhooks = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, created, msg, err_10;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setOperationLoading(true);
                    return [4 /*yield*/, webhooksApi.manageChannexWebhooks({ action: 'sync' })];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        created = response.created_count || 0;
                        msg = '';
                        if (created > 0) {
                            msg = "\u2705 Sync complete! Created ".concat(created, " missing webhooks in Channex.");
                        }
                        else {
                            msg = '✅ Sync complete! All local webhooks are already in Channex.';
                        }
                        if (response.errors && response.errors.length > 0) {
                            msg += "\n\n\u26A0\uFE0F Warnings:\n".concat(response.errors.join('\n'));
                        }
                        alert(msg);
                        fetchChannexWebhooks();
                    }
                    else {
                        setError('Sync failed: ' + (((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || 'Unknown error'));
                    }
                    return [3 /*break*/, 4];
                case 2:
                    err_10 = _b.sent();
                    setError(err_10 instanceof Error ? err_10.message : 'Failed to sync webhooks');
                    return [3 /*break*/, 4];
                case 3:
                    setOperationLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSyncSpecificWebhook = function (webhookId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_11;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setOperationLoading(true);
                    return [4 /*yield*/, webhooksApi.manageChannexWebhooks({
                            action: 'sync',
                            webhook_id: webhookId
                        })];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        if (response.created_count > 0) {
                            alert('✅ Sync complete! Webhook successfully created in Channex.');
                        }
                        else if (response.errors && response.errors.length > 0) {
                            alert("\u26A0\uFE0F Sync finished with warnings:\n".concat(response.errors.join('\n')));
                        }
                        else {
                            alert('✅ Webhook is already synced with Channex.');
                        }
                        fetchChannexWebhooks();
                    }
                    else {
                        setError('Sync failed: ' + (((_a = response.errors) === null || _a === void 0 ? void 0 : _a.join(', ')) || 'Unknown error'));
                    }
                    return [3 /*break*/, 4];
                case 2:
                    err_11 = _b.sent();
                    setError(err_11 instanceof Error ? err_11.message : 'Failed to sync webhook');
                    return [3 /*break*/, 4];
                case 3:
                    setOperationLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleEventChange = function (event, checked) {
        if (checked) {
            setSelectedEvents(function (prev) { return __spreadArray(__spreadArray([], prev, true), [event], false); });
        }
        else {
            setSelectedEvents(function (prev) { return prev.filter(function (e) { return e !== event; }); });
        }
    };
    var formatDate = function (dateString) {
        return new Date(dateString).toLocaleString();
    };
    if (loading) {
        return (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px", children: _jsx(CircularProgress, {}) }));
    }
    return (_jsxs(Box, { sx: { p: 3 }, children: [_jsxs(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, children: "Webhook Management" }), _jsx(Typography, { variant: "body1", color: "textSecondary", children: "Manage webhooks configured in Channex to receive real-time notifications about booking events." })] }), _jsxs(Box, { children: [_jsx(Button, { variant: "outlined", startIcon: _jsx(SyncIcon, {}), onClick: handleSyncWebhooks, sx: { mr: 1 }, disabled: operationLoading, children: "Sync Webhooks" }), _jsx(Button, { variant: "outlined", startIcon: _jsx(RefreshIcon, {}), onClick: fetchChannexWebhooks, sx: { mr: 1 }, disabled: operationLoading, children: "Refresh" }), _jsx(Button, { variant: "outlined", startIcon: testingConnection ? _jsx(CircularProgress, { size: 20 }) : _jsx(TestIcon, {}), onClick: testChannexConnection, sx: { mr: 2 }, disabled: testingConnection || operationLoading, color: (connectionStatus === null || connectionStatus === void 0 ? void 0 : connectionStatus.success) === true ? 'success' : (connectionStatus === null || connectionStatus === void 0 ? void 0 : connectionStatus.success) === false ? 'error' : 'primary', children: "Test Connection" }), _jsx(Button, { variant: "contained", startIcon: _jsx(AddIcon, {}), onClick: openCreateDialog, disabled: operationLoading, children: "Create Webhook" })] })] }), error && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, onClose: function () { return setError(null); }, children: error })), connectionStatus && (_jsxs(Alert, { severity: connectionStatus.success ? 'success' : 'error', sx: { mb: 2 }, onClose: function () { return setConnectionStatus(null); }, children: [_jsx("strong", { children: "Connection Test:" }), " ", connectionStatus.message] })), !channexWebhooks || channexWebhooks.length === 0 ? (_jsxs(Paper, { sx: { p: 4, textAlign: 'center' }, children: [_jsx(WebhookIcon, { sx: { fontSize: 64, color: 'text.secondary', mb: 2 } }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: "No webhooks configured" }), _jsx(Typography, { variant: "body2", color: "textSecondary", sx: { mb: 3 }, children: "Create your first webhook to start receiving real-time notifications from Channex." }), _jsx(Button, { variant: "contained", startIcon: _jsx(AddIcon, {}), onClick: openCreateDialog, children: "Create First Webhook" })] })) : (_jsx(Grid, { container: true, spacing: 3, children: channexWebhooks && channexWebhooks.map(function (webhook) { return (_jsx(Grid, { item: true, xs: 12, md: 6, lg: 4, children: _jsxs(Card, { children: [_jsxs(CardContent, { children: [_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, children: [_jsx(Typography, { variant: "h6", component: "div", children: "Webhook" }), _jsx(Chip, { label: webhook.is_active ? 'Active' : 'Inactive', color: webhook.is_active ? 'success' : 'default', size: "small" })] }), _jsx(Typography, { variant: "body2", color: "textSecondary", gutterBottom: true, children: _jsx("strong", { children: "URL:" }) }), _jsx(Typography, { variant: "body2", sx: { mb: 2, wordBreak: 'break-all' }, children: webhook.url }), webhook.property_id && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body2", color: "textSecondary", gutterBottom: true, children: _jsx("strong", { children: "Property:" }) }), _jsx(Typography, { variant: "body2", sx: { mb: 2 }, children: (function () {
                                                    var mapping = propertyChannelMappings.find(function (m) { return m.external_property_id === webhook.property_id; });
                                                    if (mapping) {
                                                        var property = properties.find(function (p) { return p.id === mapping.property; });
                                                        return property ? property.name : "Property ".concat(mapping.property);
                                                    }
                                                    return webhook.property_id;
                                                })() })] })), _jsx(Typography, { variant: "body2", color: "textSecondary", gutterBottom: true, children: _jsx("strong", { children: "Events:" }) }), _jsx(Box, { sx: { mb: 2 }, children: webhook.events && webhook.events.map(function (event) { return (_jsx(Chip, { label: event.replace('_', ' ').toUpperCase(), size: "small", variant: "outlined", sx: { mr: 0.5, mb: 0.5 } }, event)); }) }), _jsxs(Typography, { variant: "caption", color: "textSecondary", display: "block", children: ["Created: ", formatDate(webhook.created_at)] }), webhook.error_message && (_jsx(Alert, { severity: "warning", sx: { mt: 2, fontSize: '0.875rem' }, children: webhook.error_message }))] }), _jsxs(CardActions, { children: [_jsx(Button, { size: "small", startIcon: webhook.is_active ? _jsx(InactiveIcon, {}) : _jsx(ActiveIcon, {}), onClick: function () { return handleToggleWebhook(webhook); }, color: webhook.is_active ? "warning" : "success", disabled: operationLoading, children: webhook.is_active ? 'Deactivate' : 'Activate' }), _jsx(Button, { size: "small", startIcon: _jsx(SyncIcon, {}), onClick: function () { return handleSyncSpecificWebhook(webhook.id); }, color: "primary", disabled: operationLoading, children: "Sync" }), _jsx(Button, { size: "small", startIcon: _jsx(TestIcon, {}), onClick: function () { return handleTestWebhook(webhook); }, color: "info", disabled: operationLoading, children: "Test" }), _jsx(Button, { size: "small", startIcon: _jsx(EditIcon, {}), onClick: function () { return openEditDialog(webhook); }, disabled: operationLoading, children: "Edit" }), _jsx(Button, { size: "small", startIcon: _jsx(DeleteIcon, {}), onClick: function () { return handleDeleteWebhook(webhook.id); }, color: "error", disabled: operationLoading, children: "Delete" })] })] }) }, webhook.id)); }) })), _jsxs(Dialog, { open: createDialogOpen, onClose: function () { return setCreateDialogOpen(false); }, maxWidth: "sm", fullWidth: true, children: [_jsx(DialogTitle, { children: "Create New Webhook" }), _jsxs(DialogContent, { children: [_jsx(TextField, { autoFocus: true, margin: "dense", label: "Webhook URL", fullWidth: true, variant: "outlined", value: newWebhookUrl, onChange: function (e) { return setNewWebhookUrl(e.target.value); }, sx: { mb: 2 }, helperText: "This URL will receive webhook notifications from Channex" }), _jsxs(FormControl, { fullWidth: true, sx: { mb: 2 }, children: [_jsx(InputLabel, { children: "Select Property" }), _jsx(Select, { value: selectedPropertyId, label: "Select Property", onChange: function (e) { return setSelectedPropertyId(e.target.value); }, children: propertyChannelMappings.length > 0 ? (propertyChannelMappings.map(function (mapping) {
                                            var property = properties.find(function (p) { return p.id === mapping.property; });
                                            return (_jsxs(MenuItem, { value: mapping.external_property_id, children: [property ? property.name : "Property ".concat(mapping.property), " (", mapping.external_property_id, ")"] }, mapping.id));
                                        })) : properties.length > 0 ? (properties.map(function (property) { return (_jsxs(MenuItem, { value: property.id.toString(), children: [property.name, " (No Channex mapping)"] }, property.id)); })) : (_jsx(MenuItem, { disabled: true, value: "", children: "No properties available" })) }), properties.length === 0 && (_jsx(Typography, { variant: "caption", color: "error", sx: { mt: 1, display: 'block' }, children: "No properties found. Please create a property first." })), properties.length > 0 && propertyChannelMappings.length === 0 && (_jsx(Typography, { variant: "caption", color: "warning.main", sx: { mt: 1, display: 'block' }, children: "No Channex mappings found. Webhooks may not work properly." }))] }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedIsActive, onChange: function (e) { return setSelectedIsActive(e.target.checked); }, color: "primary" }), label: "Active" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedSendData, onChange: function (e) { return setSelectedSendData(e.target.checked); }, color: "primary" }), label: "Send Data Payload" }), _jsx(Typography, { variant: "subtitle2", sx: { mb: 1, mt: 2 }, children: "Select Events to Subscribe:" }), _jsx(FormControl, { component: "fieldset", sx: { maxHeight: 200, overflow: 'auto' }, children: availableEvents.map(function (event) { return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedEvents.includes(event), onChange: function (e) { return handleEventChange(event, e.target.checked); } }), label: event.replace('_', ' ').toUpperCase() }, event)); }) })] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: function () { return setCreateDialogOpen(false); }, children: "Cancel" }), _jsx(Button, { onClick: handleCreateWebhook, variant: "contained", disabled: operationLoading || !newWebhookUrl || selectedEvents.length === 0 || !selectedPropertyId, startIcon: operationLoading ? _jsx(CircularProgress, { size: 20 }) : _jsx(SaveIcon, {}), children: "Create" })] })] }), _jsxs(Dialog, { open: editDialogOpen, onClose: function () { return setEditDialogOpen(false); }, maxWidth: "sm", fullWidth: true, children: [_jsx(DialogTitle, { children: "Edit Webhook" }), _jsxs(DialogContent, { children: [_jsx(TextField, { autoFocus: true, margin: "dense", label: "Webhook URL", fullWidth: true, variant: "outlined", value: newWebhookUrl, onChange: function (e) { return setNewWebhookUrl(e.target.value); }, sx: { mb: 2 } }), _jsxs(FormControl, { fullWidth: true, sx: { mb: 2 }, children: [_jsx(InputLabel, { children: "Select Property" }), _jsx(Select, { value: selectedPropertyId, label: "Select Property", onChange: function (e) { return setSelectedPropertyId(e.target.value); }, children: propertyChannelMappings.length > 0 ? (propertyChannelMappings.map(function (mapping) {
                                            var property = properties.find(function (p) { return p.id === mapping.property; });
                                            return (_jsxs(MenuItem, { value: mapping.external_property_id, children: [property ? property.name : "Property ".concat(mapping.property), " (", mapping.external_property_id, ")"] }, mapping.id));
                                        })) : properties.length > 0 ? (properties.map(function (property) { return (_jsxs(MenuItem, { value: property.id.toString(), children: [property.name, " (No Channex mapping)"] }, property.id)); })) : (_jsx(MenuItem, { disabled: true, value: "", children: "No properties available" })) }), properties.length === 0 && (_jsx(Typography, { variant: "caption", color: "error", sx: { mt: 1, display: 'block' }, children: "No properties found. Please create a property first." })), properties.length > 0 && propertyChannelMappings.length === 0 && (_jsx(Typography, { variant: "caption", color: "warning.main", sx: { mt: 1, display: 'block' }, children: "No Channex mappings found. Webhooks may not work properly." }))] }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedIsActive, onChange: function (e) { return setSelectedIsActive(e.target.checked); }, color: "primary" }), label: "Active" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedSendData, onChange: function (e) { return setSelectedSendData(e.target.checked); }, color: "primary" }), label: "Send Data Payload" }), _jsx(Typography, { variant: "subtitle2", sx: { mb: 1, mt: 2 }, children: "Select Events to Subscribe:" }), _jsx(FormControl, { component: "fieldset", sx: { maxHeight: 200, overflow: 'auto' }, children: availableEvents.map(function (event) { return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: selectedEvents.includes(event), onChange: function (e) { return handleEventChange(event, e.target.checked); } }), label: event.replace('_', ' ').toUpperCase() }, event)); }) })] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: function () { return setEditDialogOpen(false); }, children: "Cancel" }), _jsx(Button, { onClick: handleUpdateWebhook, variant: "contained", disabled: operationLoading || !newWebhookUrl || selectedEvents.length === 0 || !selectedPropertyId, startIcon: operationLoading ? _jsx(CircularProgress, { size: 20 }) : _jsx(SaveIcon, {}), children: "Update" })] })] })] }));
};
export default WebhookManagement;
